import React from 'react'
import PropTypes from "prop-types";


function P2StepperItem({size, variant="active",...props}) {
  let stepperSize = size;
  let iconSize = Number(size)/ 1.5;
  let tickColor = variant === "completed" ? "#FFF" : variant === "section_completed" ? "#0C8188" : "#FFF";
  return (
    <div className='polymer-stepper-item'>
      <div className={`polymer-stepper-item__icon polymer-stepper-item__icon__${variant}`} style={{width:stepperSize, height:stepperSize}}>
        {!(variant === "completed" || variant === "section_completed") && <p className={`polymer-stepper-item__icon__text polymer-stepper-item__icon__${variant}-text`}>
          {props.step}
        </p>}
        
        {(variant === "completed" || variant === "section_completed") && <svg width={iconSize} height={iconSize} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.0003 26.9536L8.05026 20.0036L5.68359 22.3536L15.0003 31.6703L35.0003 11.6703L32.6503 9.32031L15.0003 26.9536Z" fill={tickColor}/>
        </svg>}
      </div>
      {(variant === "active" || variant === "section_active") && props.title && <div className='polymer-stepper-item__description'>
        <p>{props.title}</p>
      </div> }
    </div>
  )
}

export default P2StepperItem


P2StepperItem.propTypes = {
  variant: PropTypes.oneOf(['active', 'disabled', 'completed', 'section_active', 'section_completed']),
  step: PropTypes.string,
  title: PropTypes.string,
  size: PropTypes.number
}


P2StepperItem.defaultProps = {
  variant:"active",
};
